export const products = [
  {
    id: 1,
    name: '프로엑티브 듀오',
    category: '건강기능식품',
    desc: '두 가지 핵심 영양 성분을 하나에 담은 복합 건강기능식품으로, 일상적인 건강 관리를 더욱 간편하게 도와줍니다.',
    badge: '',
    image: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/466e3fd735a2690467753733a08b82e0.png',
    purchaseUrl: 'https://smartstore.naver.com/proactivecare/products/5848729224',
    detail: {
      subtitle: '두 가지 핵심 성분의 시너지',
      highlights: ['복합 영양 성분 함유', '간편한 1일 1회 섭취', '식약처 인증 건강기능식품', '국내 GMP 인증 공장 생산'],
      description: '프로엑티브 듀오는 두 가지 핵심 영양 성분을 하나의 제품에 최적 비율로 배합하여, 바쁜 현대인이 간편하게 건강을 관리할 수 있도록 설계된 복합 건강기능식품입니다. 엄격한 품질 기준과 식약처 인증을 통해 안전성과 효능을 모두 검증받았습니다.',
      detailImage: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/95320654d460f99cd57eb1480145913a.jpeg',
      usage: '1일 1회, 1회 1정을 충분한 물과 함께 섭취하세요.',
      usageSteps: [
        { step: '1', label: '섭취 시기', desc: '매일 일정한 시간에 섭취하면 효과적입니다.' },
        { step: '2', label: '섭취 방법', desc: '1회 1정을 충분한 물(200ml 이상)과 함께 섭취하세요.' },
        { step: '3', label: '섭취 횟수', desc: '1일 1회 섭취를 권장합니다.' },
      ],
      cautionList: [
        '어린이의 손이 닿지 않는 곳에 보관하세요.',
        '의약품이 아니므로 질병의 예방 및 치료를 위한 의약품을 대체할 수 없습니다.',
        '알레르기 체질이거나 특이 체질인 경우 섭취 전 의사와 상담하세요.',
        '개봉 후에는 직사광선을 피하고 서늘하고 건조한 곳에 보관하세요.',
        '유통기한을 확인하고 유통기한이 지난 제품은 섭취하지 마세요.',
      ],
      caution: '어린이의 손이 닿지 않는 곳에 보관하세요. 의약품이 아니므로 질병의 예방 및 치료를 위한 의약품을 대체할 수 없습니다.',
    },
  },
  {
    id: 2,
    name: '프로엑티브 오메가3',
    category: '건강기능식품',
    desc: '고순도 오메가3 지방산을 함유한 건강기능식품으로, 혈중 중성지질 개선 및 심혈관 건강 유지에 도움을 줍니다.',
    badge: '',
    image: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/b0cd0c22d484190a22b5c21e4753223e.png',
    purchaseUrl: 'https://smartstore.naver.com/proactivecare/products/5848770951',
    detail: {
      subtitle: '고순도 EPA·DHA 오메가3',
      highlights: ['EPA+DHA 고함량 함유', '혈중 중성지질 개선 도움', '분자증류 정제 공법', '비린내 없는 장용성 캡슐'],
      description: '프로엑티브 오메가3는 분자증류 정제 공법으로 불순물을 제거한 고순도 오메가3 지방산을 함유하고 있습니다. EPA와 DHA의 균형 잡힌 배합으로 혈중 중성지질 개선과 심혈관 건강 유지에 도움을 주며, 장용성 캡슐로 비린내 없이 편안하게 섭취할 수 있습니다.',
      detailImage: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/5c604cc1a32b0f26197ee01be44811c9.jpeg',
      usage: '1일 1회, 1회 1캡슐을 식후 충분한 물과 함께 섭취하세요.',
      usageSteps: [
        { step: '1', label: '섭취 시기', desc: '식사 직후 섭취하면 흡수율이 높아집니다.' },
        { step: '2', label: '섭취 방법', desc: '1회 1캡슐을 충분한 물(200ml 이상)과 함께 섭취하세요.' },
        { step: '3', label: '섭취 횟수', desc: '1일 1회 섭취를 권장합니다.' },
      ],
      cautionList: [
        '혈액응고 관련 약물(와파린 등) 복용 중인 경우 반드시 의사와 상담 후 섭취하세요.',
        '직사광선을 피해 서늘하고 건조한 곳에 보관하세요.',
        '어린이의 손이 닿지 않는 곳에 보관하세요.',
        '생선 알레르기가 있는 경우 섭취 전 의사와 상담하세요.',
        '개봉 후에는 산화 방지를 위해 밀봉하여 냉장 보관을 권장합니다.',
      ],
      caution: '혈액응고 관련 약물 복용 중인 경우 의사와 상담 후 섭취하세요. 직사광선을 피해 서늘한 곳에 보관하세요.',
    },
  },
  {
    id: 3,
    name: '프로엑티브 릴랙스',
    category: '건강기능식품',
    desc: '바쁜 일상 속 심신의 안정을 지원하는 건강기능식품으로, 스트레스 완화와 편안한 휴식에 도움을 줍니다.',
    badge: '',
    image: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/d83d0980517844af2c22f3ba2dd27061.png',
    purchaseUrl: 'https://smartstore.naver.com/proactivecare/products/6001052702',
    detail: {
      subtitle: '심신 안정을 위한 릴랙스 포뮬러',
      highlights: ['스트레스 완화 도움', '수면의 질 개선 지원', '천연 유래 성분 함유', '비수면제·비의존성'],
      description: '프로엑티브 릴랙스는 현대인의 스트레스와 피로 회복을 위해 설계된 건강기능식품입니다. 천연 유래 성분을 기반으로 심신의 긴장을 완화하고 편안한 휴식을 지원합니다. 수면제가 아닌 자연스러운 방식으로 몸의 이완을 도와 다음 날 개운한 컨디션을 유지할 수 있도록 합니다.',
      detailImage: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/d9d4b487b0a2f019e04e204c39340d58.jpeg',
      usage: '1일 2회, 1회 1정을 물과 함께 섭취하세요. 불면증이 있다면 저녁식사 후 2정을 한꺼번에 물과 함께 섭취하세요.',
      usageSteps: [
        { step: '1', label: '일반 섭취', desc: '1일 2회, 1회 1정을 물과 함께 섭취하세요.' },
        { step: '2', label: '불면증 시', desc: '저녁식사 후 2정을 한꺼번에 물과 함께 섭취하세요.' },
        { step: '3', label: '권장 시간', desc: '취침 1~2시간 전 섭취 시 더욱 효과적입니다.' },
      ],
      cautionList: [
        '임산부 및 수유 중인 여성은 섭취 전 반드시 의사와 상담하세요.',
        '운전 또는 기계 조작 전 섭취를 삼가세요.',
        '알코올과 함께 섭취하지 마세요.',
        '수면제, 항불안제 등 중추신경계 약물 복용 중인 경우 의사와 상담 후 섭취하세요.',
        '어린이의 손이 닿지 않는 곳에 보관하세요.',
      ],
      caution: '임산부 및 수유 중인 여성은 섭취 전 의사와 상담하세요. 운전 또는 기계 조작 전 섭취를 삼가세요.',
    },
  },
  {
    id: 4,
    name: '에이치씨에이 플러스',
    category: '건강기능식품',
    desc: 'HCA(하이드록시시트르산) 성분을 주원료로 한 건강기능식품으로, 체지방 감소 및 건강한 체중 관리를 도와줍니다.',
    badge: '',
    image: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/a4af585d0a557ffde30aae3a4376642c.png',
    purchaseUrl: 'https://smartstore.naver.com/proactivecare/products/5601694188',
    detail: {
      subtitle: 'HCA 고함량 체중 관리 솔루션',
      highlights: ['HCA 고함량 함유', '체지방 감소 도움', '식욕 조절 지원', '운동 효과 극대화'],
      description: '에이치씨에이 플러스는 가르시니아 캄보지아에서 추출한 HCA(하이드록시시트르산)를 주원료로 하여 체지방 감소와 건강한 체중 관리를 지원하는 건강기능식품입니다. 규칙적인 운동과 균형 잡힌 식단과 함께 섭취 시 더욱 효과적인 체중 관리 효과를 기대할 수 있습니다.',
      detailImage: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/6281049763fece90639bfa4fcbe038ba.jpeg',
      usage: '1일 3회, 식사 30분 전 1포씩 물과 함께 섭취하세요.',
      usageSteps: [
        { step: '1', label: '섭취 시기', desc: '식사 30분 전에 섭취하면 식욕 조절 효과가 높아집니다.' },
        { step: '2', label: '섭취 방법', desc: '1회 1포를 충분한 물(200ml 이상)과 함께 섭취하세요.' },
        { step: '3', label: '섭취 횟수', desc: '1일 3회(아침·점심·저녁 식전) 섭취를 권장합니다.' },
      ],
      cautionList: [
        '매우 드물지만 간기능 수치가 상승할 수 있으므로 정기적으로 간기능 검사를 확인하세요.',
        '15세 미만 어린이는 섭취를 삼가세요.',
        '간 질환이 있거나 간 관련 약물 복용 중인 경우 의사와 상담 후 섭취하세요.',
        '임산부 및 수유 중인 여성은 섭취 전 의사와 상담하세요.',
        '어린이의 손이 닿지 않는 곳에 보관하세요.',
      ],
      caution: '매우 드물지만 간기능 수치가 상승할 수 있습니다. 정기적으로 간기능 검사를 확인하세요. 15세 미만 어린이는 섭취를 삼가세요.',
    },
  },
];
